export const allowLettersNumbersUnicodeWithSpace = (value) => {
    return String(value).replace(/[^\p{L}\p{N} ]/gu, "");
};

export const allowEnglishTamilWithSpace = (value) => {
    return String(value).replace(/[^A-Za-z\u0B80-\u0BFF ]/g, "");
};

export const allowOnlyNumbers = (value) => {
    return String(value).replace(/\D/g, "");
};

export const isValidTenDigitPhone = (value) => {
    return /^\d{10}$/.test(String(value));
};

export const allowEnglishTamilWithSpaceAndDot = (value) => {
    return String(value).replace(/[^A-Za-z\u0B80-\u0BFF. ]/g, "");
};

export const allowEmailCharacters = (value) => {
    return String(value).replace(/[^A-Za-z0-9.@_-]/g, "");
};


/* New functions */

/* Address: text, numbers, spaces, ., ,, /, #, - */
export const allowAddressCharacters = (value) => {
    return String(value).replace(
        /[^\p{L}\p{N} .,/#-]/gu,
        ""
    );
};

/* Phone: numbers, +, -, spaces */
export const allowPhoneCharacters = (value) => {
    return String(value).replace(/[^0-9+\- ]/g, "");
};

/* Numbers + spaces */
export const allowNumbersWithSpace = (value) => {
    return String(value).replace(/[^0-9 ]/g, "");
};

/* Exactly 6 digits */
export const isValidSixDigitPincode = (value) => {
    return /^\d{6}$/.test(String(value));
};

// googlemaps
export const isValidGoogleMapsEmbedUrl = (value) => {
    if (!value || typeof value !== "string") {
        return false;
    }

    try {
        const url = new URL(value.trim());

        return (
            url.protocol === "https:" &&
            url.hostname === "www.google.com" &&
            url.pathname === "/maps/embed" &&
            url.searchParams.has("pb")
        );
    } catch {
        return false;
    }
};